module.exports = __webpack_public_path__ + "img/1-sm.9aa476ea.jpg";